/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SignInMessageResponse
 */
export interface SignInMessageResponse {
  /**
   *
   * @type {object}
   * @memberof SignInMessageResponse
   */
  types?: object
  /**
   *
   * @type {string}
   * @memberof SignInMessageResponse
   */
  primaryType?: string
  /**
   *
   * @type {object}
   * @memberof SignInMessageResponse
   */
  domain?: object
  /**
   *
   * @type {object}
   * @memberof SignInMessageResponse
   */
  message?: object
}

export function SignInMessageResponseFromJSON(json: any): SignInMessageResponse {
  return SignInMessageResponseFromJSONTyped(json, false)
}

export function SignInMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignInMessageResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    types: !exists(json, 'types') ? undefined : json['types'],
    primaryType: !exists(json, 'primaryType') ? undefined : json['primaryType'],
    domain: !exists(json, 'domain') ? undefined : json['domain'],
    message: !exists(json, 'message') ? undefined : json['message'],
  }
}

export function SignInMessageResponseToJSON(value?: SignInMessageResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    types: value.types,
    primaryType: value.primaryType,
    domain: value.domain,
    message: value.message,
  }
}
